module.exports = __webpack_public_path__ + "df41c6bc1e5e178f05c46e94b34e11e7.png";